export const filterConfigMapping = {
  fieldMappings: {
    Assignee: {
      type: "checkbox",
      expanded: true,
      isVisible: true,
      isDefault: true,
      fieldName: "disputeAgentName",
      isLoading: true,
    },
    "Assignee id": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "disputeAgentApmId",
      isLoading: true,
    },
    "Assignee email": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "disputeAgentEmail",
      isLoading: true,
    },
    Area: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "areaName",
      isLoading: true,
    },
    "Area code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "areaCode",
      isLoading: true,
    },
    "Is Archived Invoice": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isArchivedInvoice",
      isLoading: true,
    },
    "Reason for delay in resolution": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "resolutionDelayReason",
      isLoading: true,
    },
    "Billing document date": {
      type: "date",
      expanded: false,
      fieldName: "billingDocumentDate",
      isVisible: true,
      isDefault: true,
      isLoading: true,
    },
    Brand: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "brand",
      isLoading: true,
    },
    "Bulk Create Id": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "bulkCreateId",
      isLoading: true,
    },
    "Business area code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "businessAreaCode",
      isLoading: true,
    },
    "Business area description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "businessAreaDescription",
      isLoading: true,
    },
    "Case Aging": {
      type: "checkbox",
      expanded: false,
      isVisible: false,
      isDefault: true,
      fieldName: "caseAging",
      isLoading: true,
    },
    "Case title": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "caseTitle",
      isLoading: true,
    },
    "Case type": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "caseType",
      isLoading: true,
    },
    "Case number": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "cmCaseNumber",
      isLoading: true,
    },
    Carrier: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "carrier",
      isLoading: true,
    },
    "Customer disputed amount": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "custDisputedAmt",
      isLoading: true,
    },
    Customer: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "customer",
      isLoading: true,
    },
    "Customer type": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "customerType",
      isLoading: true,
    },
    Category: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "categoryCode",
      isLoading: true,
    },
    "Category description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "categoryDescription",
      isLoading: true,
    },
    "Changed by": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "changedBy",
      isLoading: true,
    },
    "Charge code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "chargeCode",
      isLoading: true,
    },
    "Closed at": {
      type: "date",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "closedTs",
      isLoading: true,
    },
    "Closed by": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "closedBy",
      isLoading: true,
    },
    "Coordinator code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "coordinatorCode",
      isLoading: true,
    },
    "Coordinator function": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "coordinatorFunction",
      isLoading: true,
    },
    "Contingency reason": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "contingencyReason",
      isLoading: true,
    },
    "Contingency reason updated by": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "contingencyReasonUpdatedBy",
      isLoading: true,
    },
    "Contact person": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "contactPerson",
      isLoading: true,
    },
    "Contact email": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "contactEmail",
      isLoading: true,
    },
    "Contact fax number": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "contactFaxNumber",
      isLoading: true,
    },
    "Contact number": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "contactTelNumber",
      isLoading: true,
    },
    "Contract correction": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "contractCorrection",
      isLoading: true,
    },
    "Company code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "companyCode",
      isLoading: true,
    },
    "Company description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "companyDescription",
      isLoading: true,
    },
    Country: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "countryName",
      isLoading: true,
    },
    "Country code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "countryCode",
      isLoading: true,
    },
    "Created by": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "createdBy",
      isLoading: true,
    },
    "Created source": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "createdSource",
      isLoading: true,
    },
    "Credit note": {
      type: "checkbox",
      expanded: false,
      isVisible: false,
      isDefault: true,
      fieldName: "creditNote",
      isLoading: true,
    },
    Currency: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "currency",
      isLoading: true,
    },
    "Customer Name": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "customerName",
      isLoading: true,
    },
    "Dispute stage": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "disputeStage",
      isLoading: true,
    },
    "Dispute sub status": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "disputeSubStatus",
      isLoading: true,
    },
    "Dispute type": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "disputeType",
      isLoading: true,
    },
    "Dispute amount": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "disputedAmount",
      isLoading: true,
    },
    "Dispute origin": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "disputeOrigin",
      isLoading: true,
    },
    "Dispute outcome code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "disputeOutcomeCode",
      isLoading: true,
    },
    "Dispute outcome description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "disputeOutcomeDescription",
      isLoading: true,
    },
    "Dispute voice agent": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "ohpDisputeVoiceAgent",
      isLoading: true,
    },
    "Document type": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "documentType",
      isLoading: true,
    },
    "Expected amount": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "expectedAmount",
      isLoading: true,
    },
    "FSCM changed by": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "fscmChangedBy",
      isLoading: true,
    },
    "FSCM created by": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "fscmCreatedBy",
      isLoading: true,
    },
    "FSCM closed by": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "fscmClosedBy",
      isLoading: true,
    },
    "FSCM changed at": {
      type: "date",
      expanded: false,
      fieldName: "fscmChangedTs",
      isLoading: true,
      isVisible: true,
      isDefault: true,
    },
    "FSCM created at": {
      type: "date",
      expanded: false,
      fieldName: "fscmCreatedTs",
      isLoading: true,
      isVisible: true,
      isDefault: true,
    },
    "FSCM closed at": {
      type: "date",
      expanded: false,
      fieldName: "fscmClosedTs",
      isLoading: true,
      isVisible: true,
      isDefault: true,
    },
    GSC: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "gsc",
      isLoading: true,
    },
    "Invoice amount": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "invoiceAmount",
      isLoading: true,
    },
    "Invoice number": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "invoiceNumber",
      isLoading: true,
    },
    "Incident Id": {
      type: "checkbox",
      expanded: false,
      isVisible: false,
      isDefault: true,
      fieldName: "incidentId",
      isLoading: true,
    },
    "Is Credit Note Available": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isCreditNoteCreated",
      isLoading: true,
    },
    "Is Incident Created": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isIncidentCreated",
      isLoading: true,
    },
    "Is FMC": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isFmcRegulated",
      isLoading: true,
    },
    "Is redispute": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isRedisputed",
      isLoading: true,
    },

    "Is SLA Missed": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isSLAMissed",
      isLoading: true,
    },
    "Is spot": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isSpot",
      isLoading: true,
    },
    "Is tender": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isTender",
      isLoading: true,
    },
    "ISR raised": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isrRaised",
      isLoading: true,
    },
    "Auto Resolution Outcome": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "autoResolutionOutcome",
      isLoading: true,
    },
    "No. of containers": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "noOfContainers",
      isLoading: true,
    },
    ODN: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "odn",
      isLoading: true,
    },
    "OHP Dispute id": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "ohpDisputeId",
      isLoading: true,
    },
    "OHP changed at": {
      type: "date",
      expanded: true,
      fieldName: "changedTs",
      isLoading: true,
      isVisible: true,
      isDefault: true,
    },
    "OHP created at": {
      type: "date",
      expanded: false,
      fieldName: "createdTs",
      isLoading: true,
      isVisible: true,
      isDefault: true,
    },
    "Original disputed amount": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "originalDisputedAmount",
      isLoading: true,
    },
    "Payment type": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "paymentType",
      isLoading: true,
    },
    "Processor name": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "processorName",
      isLoading: true,
    },
    "Price owner name": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "priceOwnerName",
      isLoading: true,
    },
    "Price owner code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "priceOwnerScvCode",
      isLoading: true,
    },
    "Reason code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "reasonCode",
      isLoading: true,
    },
    "Reason description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "reasonDescription",
      isLoading: true,
    },
    "Redispute category": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "redisputeCategory",
      isLoading: true,
    },
    "Redispute category description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "redisputeCategoryDescription",
      isLoading: true,
    },
    "Redispute count": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "redisputeCount",
      isLoading: true,
    },
    "Redispute outcome code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "redisputeOutcomeCode",
      isLoading: true,
    },
    "Redispute outcome description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "redisputeOutcomeDescription",
      isLoading: true,
    },
    "Redispute root cause code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "redisputeRootCauseCode",
      isLoading: true,
    },
    "Redispute root cause description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "redisputeRootCauseDescription",
      isLoading: true,
    },
    "Reference key": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "referenceKey",
      isLoading: true,
    },
    Region: {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "regionName",
      isLoading: true,
    },
    "Resolution Time": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "resolutionTat",
      isLoading: true,
    },
    "Region code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "regionCode",
      isLoading: true,
    },
    "Root cause code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "rootCauseCode",
      isLoading: true,
    },
    "Root cause description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "rootCauseDescription",
      isLoading: true,
    },
    "Status code": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "statusCode",
      isLoading: true,
    },
    "Status description": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "statusDescription",
      isLoading: true,
    },
    "Team leader": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "teamLeader",
      isLoading: true,
    },
    "TP doc number": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "tpDocumentNumber",
      isLoading: true,
    },

    "Hand Over to Collections": {
      type: "checkbox",
      expanded: false,
      isVisible: true,
      isDefault: true,
      fieldName: "isHandedOverToCollections",
      isLoading: true,
    },
  },
  defaultValues: {
    Assignee: [],
    "Assignee id": [],
    "Assignee email": [],
    Area: [],
    "Area code": [],
    "Is Archived Invoice": [],
    "Reason for delay in resolution": [],
    "Billing document date": [],
    Brand: [],
    "Bulk Create Id": [],
    "Business area code": [],
    "Business area description": [],
    "Case Aging": [],
    "Case title": [],
    "Case type": [],
    "Case number": [],
    Carrier: [],
    "Customer disputed amount": [],
    Customer: [],
    "Customer type": [],
    Category: [],
    "Category description": [],
    "Changed by": [],
    "Charge code": [],
    "Closed by": [],
    "Coordinator code": [],
    "Coordinator function": [],
    "Contingency reason": [],
    "Contingency reason updated by": [],
    "Contact person": [],
    "Contact email": [],
    "Contact fax number": [],
    "Contact number": [],
    "Contract correction": [],
    "Company code": [],
    "Company description": [],
    Country: [],
    "Country code": [],
    "Created by": [],
    "Created source": [],
    "Credit Note": [],
    Currency: [],
    "Customer Name": [],
    "Dispute stage": [],
    "Dispute sub status": [],
    "Dispute type": [],
    "Dispute amount": [],
    "Dispute origin": [],
    "Dispute outcome code": [],
    "Dispute outcome description": [],
    "Dispute voice agent": [],
    "Document type": [],
    "Expected amount": [],
    "FSCM changed by": [],
    "FSCM created by": [],
    "FSCM closed by": [],
    "FSCM changed at": [],
    "FSCM created at": [],
    "FSCM closed at": [],
    GSC: [],
    "Invoice amount": [],
    "Invoice number": [],
    "Incident Id": [],
    "Is Credit note Created": [],
    "Is Incident Created": [],
    "Is FMC": [],
    "Is redispute": [],
    "ISR raised": [],
    "Is SLA Missed": [],
    "Is spot": [],
    "Is tender": [],
    "Auto Resolution Outcome": [],
    "No. of containers": [],
    ODN: [],
    "OHP dispute id": [],
    "OHP changed at": [],
    "OHP created at": [],
    "Original disputed amount": [],
    "Payment type": [],
    "Processor name": [],
    "Price owner name": [],
    "Price owner code": [],
    "Reference key": [],
    Region: [],
    "Region code": [],
    "Reason code": [],
    "Reason description": [],
    "Redispute category": [],
    "Redispute category description": [],
    "Redispute count": [],
    "Redispute outcome code": [],
    "Redispute outcome description": [],
    "Redispute root cause code": [],
    "Redispute root cause description": [],
    "Resolution Time": [],
    "Root cause code": [],
    "Root cause description": [],
    "Status code": [],
    "Status description": [],
    "Team leader": [],
    "TP doc number": [],
    "Hand Over to Collections": [],
  },
};

export const defaultFilterColumns = [
  "Assignee",
  "Assignee id",
  "Assignee email",
  "Area",
  "Area code",
  "Is Archived Invoice",
  "Reason for delay in resolution",
  "Billing document date",
  "Brand",
  "Business area code",
  "Business area description",
  "Bulk Create Id",
  "Case Aging",
  "Case title",
  "Case type",
  "Case number",
  "Carrier",
  "Customer disputed amount",
  "Customer",
  "Customer type",
  "Category",
  "Category description",
  "Changed by",
  "Charge code",
  "Closed by",
  "Coordinator code",
  "Coordinator function",
  "Contingency reason",
  "Contingency reason updated by",
  "Contact person",
  "Contact email",
  "Contact fax number",
  "Contact number",
  "Contract correction",
  "Company code",
  "Company description",
  "Country",
  "Country code",
  "Created by",
  "Created source",
  "Credit Note",
  "Currency",
  "Customer name",
  "Dispute stage",
  "Dispute type",
  "Dispute amount",
  "Dispute origin",
  "Dispute outcome code",
  "Dispute outcome description",
  "Dispute voice agent",
  "Document type",
  "Expected amount",
  "FSCM changed by",
  "FSCM created by",
  "FSCM closed by",
  "Dispute sub status",
  "FSCM changed at",
  "FSCM created at",
  "FSCM closed at",
  "GSC",
  "Invoice amount",
  "Invoice number",
  "Incident Id",
  "Is Credit note Created",
  "Is Incident Created",
  "Is FMC",
  "Is redispute",
  "ISR raised",
  "Is SLA Missed",
  "Is spot",
  "Is tender",
  "Auto Resolution Outcome",
  "No. of containers",
  "ODN",
  "OHP dispute id",
  "OHP changed at",
  "OHP created at",
  "Original disputed amount",
  "Payment type",
  "Processor name",
  "Price owner name",
  "Price owner code",
  "Reference key",
  "Region",
  "Region code",
  "Reason code",
  "Reason description",
  "Redispute category",
  "Redispute category description",
  "Redispute count",
  "Redispute outcome code",
  "Redispute outcome description",
  "Redispute root cause code",
  "Redispute root cause description",
  "Resolution Time",
  "Root cause code",
  "Root cause description",
  "Status code",
  "Status description",
  "Team leader",
  "TP doc number",
  "Hand Over to Collections",
];

export const relativeDateOptions = [
  {
    label: "Range",
    value: "range",
  },
  {
    label: "Exact",
    value: "exact",
  },
];

export const numberOfCasesOptions = [
  {
    value: "",
    label: "Select Number of cases",
    disabled: false,
  },
  {
    value: 1,
    label: "1",
    disabled: false,
  },
  {
    value: 2,
    label: "2",
    disabled: false,
  },
  {
    value: 3,
    label: "3",
    disabled: false,
  },
  {
    value: 4,
    label: "4",
    disabled: false,
  },
  {
    value: 5,
    label: "5",
    disabled: false,
  },
  {
    value: 6,
    label: "6",
    disabled: false,
  },
  {
    value: 7,
    label: "7",
    disabled: false,
  },
  {
    value: 8,
    label: "8",
    disabled: false,
  },
  {
    value: 9,
    label: "9",
    disabled: false,
  },
  {
    value: 10,
    label: "10",
    disabled: false,
  },
];
